import { DURATION_INIT, SHOW_MILESTONES_INIT } from 'app/utils/constants/contactApp';
import { createSlice } from '@reduxjs/toolkit';

export const toggleSidebarSlice = createSlice({
  name: 'toggleSidebar',
  initialState: {
    isSidebarToggled: false,
    isAlertOpen: false,
    visible: true,
    showMileStone: SHOW_MILESTONES_INIT,
    mileStonesDuration: DURATION_INIT,
    version2: true,
  },
  reducers: {
    // setVersion2(state, { payload }) {
    //   state.version2 = payload;
    // },
    setShowMileStone(state, { payload }) {
      state.showMileStone = payload;
    },
    setMileStonesDuration(state, { payload }) {
      state.mileStonesDuration = payload;
    },
    setToggleSidebar(state) {
      state.isSidebarToggled = !state.isSidebarToggled;
    },
    // This is a legacy feature, to create/show an alert use showAlert from utils instead
    setAlertOpen(state, { payload }) {
      state.isAlertOpen = payload;
    },

    setVisibleFalse(state) {
      state.visible = false;
    },

    setVisibleTrue(state) {
      state.visible = true;
    },
  },
});
export const {
  setToggleSidebar,
  setAlertOpen,
  setVisibleFalse,
  setVisibleTrue,
  setShowMileStone,
  setMileStonesDuration,
  // setVersion2,
} = toggleSidebarSlice.actions;
export default toggleSidebarSlice.reducer;
